<template>
  <div>
    <div class="table-cadu" style="width: 100%">
        <v-row align="center" no-gutters v-if="items">
            <v-col cols="auto" v-if="rows.length > 0"> Exibir </v-col>
            <v-col cols="auto" v-if="rows.length > 0">
                <v-select
                  class="relative primary1--text"
                  full-width
                  color="primary1"
                  item-color="primary1"
                  :append-icon="'$vuetify.icons.chevron-down'"
                  :items="items"
                  v-model="elementsPerPage"
                />
            </v-col>
            <v-col cols="auto" v-if="rows.length > 0"> resultados </v-col>
            <v-row :class="$vuetify.breakpoint.xs ? 'align-center justify-center': 'align-end justify-end'">
              <v-col cols="auto">
                <slot name="header">
                </slot>
              </v-col>
            </v-row>
        </v-row>
        <div class="table" :style="$vuetify.breakpoint.xs ? { 'width': '229px;', 'height': '100%;', 'overflow': 'auto' } : {}">
          <transition name="fade">
            <v-row v-if="showSelected" class="selected">
              <v-col cols="auto">
                <div class="primary1--text font-weight-bold title">
                  {{selectedSize}} Itens selecionados
                </div>
              </v-col>
              <v-row align="end" justify="end">
                <v-col cols="auto">
                  <button-rounded
                    class="mr-9"
                    @click="emitDeleteSelected()"
                    iconName='trash'
                    :iconSize='16'
                  />
                </v-col>
              </v-row>
            </v-row>
          </transition>
          <table rules="groups" style="width: 100%" :style="$vuetify.breakpoint.xs ? { 'width': '229px;', 'height': '100%;', 'overflow': 'auto' } : {}">
              <thead @mouseover="hoverRow(-1)" @mouseleave="downRow">
                  <tr>
                      <th v-if="showCheck">
                          <label class="form-checkbox">
                              <input :disabled="rows.length <= 0 || disabledCheckAll || !editar" type="checkbox" v-model="selectAll" @click="select">
                              <icon class="form-icon white--text" style="border-color: #60656C;" name="check" :size="16" />
                          </label>
                      </th>
                      <th v-for="(col, index) in rowsHeader" :key="index">
                        <div v-if="col.icon" style="cursor: pointer" @click="ordenaTabela(index)">
                          {{col.text}} <icon style="transform: rotate(90deg);" :name="col.icon" :size="20"/>
                        </div>
                        <div v-else @mouseover="hoverRowHeader(index)">
                          <div v-if="col.tooltip">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  {{col.text}}
                                </div>
                              </template>
                              <span>{{col.tooltip}}</span>
                            </v-tooltip>
                          </div>
                          <div v-else>
                            {{col.text}}
                          </div>
                        </div>
                        <div v-if="col == sortColumn" class="font-weight-bold"></div>
                      </th>
                  </tr>
              </thead>
              <tbody v-if="custom && rows.length > 0">
                <slot name="tr">
                </slot>
              </tbody>
              <tbody v-else-if="!custom && rows.length > 0">
                  <tr v-for="(row, index) in get_rows()" :key="index" @mouseover="hoverRow(index)" @mouseleave="downRow">
                      <td v-if="showCheck">
                        <label class="form-checkbox">
                          <input type="checkbox" :value="row.id" v-model="selected" :disabled="!editar">
                          <icon class="form-icon white--text" name="check" :size="16" />
                        </label>
                      </td>
                      <td> {{row.tipo}} </td>
                      <td> {{row.cidade}} </td>
                      <td> {{row.estado}} </td>
                      <td> {{row.regiaoGeografica}} </td>
                      <td class="pa-0 pl-2">
                        <icon v-if="row.principal && !showActionsLine(hoverIndex, index)" name="check" :size="12" class="primary1--text"/>
                        <div style="display: inline-flex" v-if="showActionsLine(hoverIndex, index)">
                          <button-rounded
                            style="width: 26px"
                            class="mr-1"
                            @click="$emit('clickButton', { index, type: 'view' })"
                            iconName='eye'
                            :iconSize='16'
                            v-if="!showSelected"
                          />
                          <button-rounded
                            style="width: 26px"
                            class="mr-1"
                            @click="$emit('clickButton', { index, type: 'edit' })"
                            iconName='edit'
                            :iconSize='16'
                            v-if="showsButtons"
                          />
                          <button-rounded
                            style="width: 26px"
                            @click="$emit('clickButton', { index, type: 'delete' })"
                            iconName='trash'
                            :iconSize='16'
                            v-if="editar"
                          />
                        </div>
                      </td>
                  </tr>
              </tbody>
              <tbody v-else-if="rows.length != 0">
                <td>
                  <label class="form-checkbox">
                    <input :disabled="true" type="checkbox" v-model="selectAll" @click="select">
                    <icon class="form-icon white--text" style="border-color: #60656C;" name="check" :size="16" />
                  </label>
                </td>
                <td v-for="(r, index) in rowsHeader" :key="index">
                  SEM DADO
                </td>
              </tbody>

          </table>
          <div style="text-align:center;" v-if="rows.length == 0">Nenhum registro encontrado</div>
        </div>
        <v-row align="start" justify="start" v-if="qtResultados > 0">
            <v-col cols="auto">
                <div>
                  Exibindo página {{currentPage}} de {{rowsLength}} {{rowsLength > 1 ? 'páginas': 'página'}}.
                </div>
            </v-col>
            <v-row v-if="pagina > 0 && qtPaginas > 0 && qtResultados > 0" :class="$vuetify.breakpoint.xs ? 'align-center justify-center' : 'align-end justify-end'" no-gutters>
                <v-col cols="auto">
                      <button
                        class="set"
                        :disabled="currentPage === 1"
                        @click="change_page(1)"
                      >
                        <icon name="chevrons-left" :size="12"/>
                      </button>
                      <button
                        class="set"
                        :disabled="currentPage === 1"
                        @click="change_page(currentPage - 1)"
                      >
                        <icon name="chevron-left" :size="12"/>
                      </button>
                      <div class="number"
                        v-for="(i, index) in num_pages()"
                        :key="index"
                        :class="[i === currentPage ? 'active' : '']"
                        @click="change_page(i)">{{i}}
                      </div>
                      <button
                        class="set"
                        :disabled="currentPage === qtPaginas || qtPaginas === 0"
                        @click="change_page(currentPage + 1)"
                      >
                        <icon name="chevron-right" :size="12"/>
                      </button>
                      <button
                        class="set"
                        :disabled="currentPage === qtPaginas || qtPaginas === 0"
                        @click="change_page(qtPaginas)"
                      >
                        <icon name="chevrons-right" :size="12"/>
                      </button>
                </v-col>
            </v-row>
        </v-row>
    </div>
    <v-row v-if="texto">
      <v-col>
        <a @click="$emit('clickButton', { type: 'add' })" style="color: #1492E6;"> {{texto}} </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false
    },
    rows: {
      type: Array,
      required: false
    },
    rowsHeader: {
      type: Array,
      required: false
    },
    texto: {
      type: String,
      required: false,
      default: ''
    },
    custom: {
      type: Boolean,
      required: false,
      default: false
    },
    elementsPerPageProp: {
      type: String,
      required: false,
      default: '05'
    },
    pagina: {
      type: Number,
      required: false,
      default: 0
    },
    qtPaginas: {
      type: Number,
      required: false,
      default: 0
    },
    qtResultados: {
      type: Number,
      required: false,
      default: 0
    },
    items: {
      type: Array,
      required: false
    },
    editar: {
      type: Boolean,
      required: false,
      default: false
    },
    disabledCheckAll: {
      type: Boolean
    },
    showCheck: {
      type: Boolean,
      required: false,
      default: true,
      note: 'Mostrar os checks na tabela'
    }
  },
  data () {
    return {
      selected: this.value ? this.value : [],
      selectAll: false,
      currentPage: 1,
      elementsPerPage: this.elementsPerPageProp,
      ascending: false,
      sortColumn: '',
      hoverIndex: -1,
      button: [],
      showButton: false,
      showSelected: false,
      ordem: 'asc',
      showButtons: false,
      hoverIndexHeader: -1
    }
  },
  methods: {
    ordenaTabela (index) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'
      this.$emit('ordena', { index: index, ordem: this.ordem })
    },
    emitDeleteSelected () {
      this.$emit('clickButton', { selected: this.selected, type: 'delAll' })
      this.selected = []
      this.selectAll = false
      this.$emit('input', [])
    },
    sortTable (col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }

      var ascending = this.ascending

      this.rows.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    num_pages () {
      let pages = []
      let index = this.currentPage

      if (this.qtPaginas === 1) {
        pages = [index]
      } else if (index === 1 && this.qtPaginas === 2) {
        pages = [index, index + 1]
      } else if (index > 1 && this.qtPaginas === 2) {
        pages = [index - 1, index]
      } else if (index > 1 && index + 1 < this.qtPaginas) {
        pages = [index - 1, index, index + 1]
      } else if (index > 0 && index + 1 < this.qtPaginas) {
        pages = [index, index + 1, index + 2]
      } else if (!(index === this.qtPaginas) && this.qtPaginas - index < 2) {
        pages = [index - 1, index, index + 1]
      } else {
        pages = [index - 2, index - 1, index]
      }

      return pages
    },
    get_rows () {
      return this.rows
    },
    change_page (page) {
      this.currentPage = page
      this.selectAll = false
      this.selected = []
      this.$emit('change-page', { currentPage: this.currentPage, elementsPerPage: this.elementsPerPage })
    },
    select () {
      if (!this.selectAll) {
        for (let i in this.rows) {
          let row = this.rows[i]
          if (!this.selected.includes(row.id)) {
            this.selected.push(row.id)
          }
        }
      } else {
        this.selected = []
      }
      this.$emit('input', this.selected)
    },
    hoverRowHeader (index) {
      //
    },
    hoverRow (index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow () {
      this.hoverIndex = -100
      this.showButton = false
    },
    cleanSelected () {
      // this.selected = []
      this.$emit('input', [])
    },
    showActionsLine (hoverIndex, index) {
      if (this.showSelected) {
        return false
      } else if (this.selected.length === 1) {
        if (hoverIndex >= 0) {
          if (this.rows[index].id === this.selected[0]) {
            return true
          } else {
            return false
          }
        }
      } else if (hoverIndex === index) {
        return true
      } else {
        return false
      }

      // if(index >= 0){
      //   if(this.showSelected){
      //     if(this.rows[index].id === this.selected[0]){
      //       return true
      //     }else{
      //       return false
      //     }
      //   }else{
      //     return this.showButton && index === id
      //   }
      // }else{
      //   return true
      // }
    }
  },
  computed: {
    columns () {
      if (this.rows.length === 0) {
        return []
      }
      return Object.keys(this.rows[0])
    },
    mostrandoLength () {
      return this.rows.length < 10 ? `0${this.rows.length}` : this.rows.length
    },
    rowsLength () {
      return Math.ceil(this.qtResultados / this.elementsPerPage)
    },
    selectedSize () {
      return this.selected.length < 10 ? `0${this.selected.length}` : this.selected.length
    },
    showsButtons () {
      if (!this.editar) return false
      return !this.showSelected
    }
  },
  watch: {
    value () {
      this.selected = this.value
    },
    selected () {
      if (this.selected.length >= 2) {
        this.showSelected = true
      } else if (this.selected.length <= 1) {
        this.selectAll = false
        this.showSelected = false
      }
    },
    elementsPerPage () {
      this.selectAll = false
      this.selected = []
      this.$emit('change-element', { elementsPerPage: this.elementsPerPage })
    },
    pagina () {
      this.currentPage = this.pagina
    }
  }
}
</script>

<style lang="sass">
@import '@/sass/table.sass'
</style>
